export const CorrectionSideBar = [
  {
    title: "Корректировка",
    to: { name: "correction_view" },
    iconName: "PenIcon",
  },
  {
    title: "Выгрузки",
    to: { name: "correction_reports" },
    iconName: "ReportsIcon",
  },
];
